import { useEffect, useState } from "react";
import { useScreenListener } from "../../providers";
import { OpenTypes, UseSidebarProps } from "./types";

export const useSidebar = ({ open: _open = "close-full" }: UseSidebarProps) => {
  const { size } = useScreenListener();
  const [open, setIsOpen] = useState<OpenTypes>(_open);

  useEffect(() => {
    setIsOpen(_open);
  }, [_open]);

  const onClose = () => {
    const body = document.getElementsByTagName("body")[0];
    body.setAttribute("style", ``);

    setIsOpen("closing");

    setTimeout(() => {
      setIsOpen("close");
    }, 100);

    setTimeout(() => {
      setIsOpen("close-full");
    }, 700);
  };

  const onOpen = () => {
    if (size < 4) {
      const body = document.getElementsByTagName("body")[0];
      body.setAttribute("style", `overflow:hidden;`);

      setIsOpen("opening");

      setTimeout(() => {
        setIsOpen("open");
      }, 100);
    }
  };

  return { open, onClose, onOpen };
};
